import { React, useRef, useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import CalcDate from '../../Model/Share/Normal/CalcDate';

import MorePath from '../../image/More.png';
import HoverMorePath from '../../image/HoverMore.png';
import ExpireMorePath from '../../image/ExpireMore.png';

const LockerInfo = forwardRef((props, ref) => {
  const { index, data, clickMoreButtonFn, clickFunctionFn, clickUsageHistoryFn, clickChangeStateFn, clickDeleteLockerFn, clickChangeNameFn, isOver } = props;
  // const [data, setData] = useState(data);
  const [clickedMore, setClickedMore] = useState(false);
  const [individualData, setIndividualData] = useState();

  const MoreButtonRef = useRef();
  const MoreBoxRef = useRef();
  const HistoryRef = useRef();
  const TextRef = useRef();
  const LockRef = useRef();
  const DeleteRef = useRef();
  const ChangeRef = useRef();

  const history = useHistory();

  useImperativeHandle(ref, () => ({
		setClickedMore: (val) => {
      setClickedMore(val);
    },
    getMoreButtonRef: () => {
      return MoreButtonRef.current;
    },
    getMoreBoxRef: () => {
      return MoreBoxRef.current;
    }
	}));

  useEffect(() => {

    if (data.state === 'Empty') {
      data.isAvailable = true;
      data.isUsed = false;
      data.state = '비어있음';
      data.days = '';
      data.btnText = '사용 시작';
      data.border = '1px solid #777777';
      // data = Object.assign(data, {days: dDay, btnText: '사용 시작'});
    }
    else if (data.state === 'Using') {
      data.isAvailable = true;
      data.isUsed = true;
      data.state = '사용중'
      data.days = CalcDate.getDday(data.endDate);
      data.btnText = '사용 종료';
      data.border = (moment(data.endDate).isAfter(moment()) || moment(data.endDate).format('YYYY.MM.DD') === moment().format('YYYY.MM.DD')) ? '2px solid #5BD98A' : `2px solid #FF3131`;
      
      // data = Object.assign(data, {days: dDay, btnText: '사용 종료'});
    }
    else if (data.state === 'Invalid') {
      data.isAvailable = false;
      data.isUsed = false;
      data.state = '사용불가'
      data.days = '';
      data.btnText = '잠금 해제';
      data.border = '1px solid #DEDEDE';
      // data = Object.assign(data, {days: '', btnText: '잠금 해제'});
    }

    setIndividualData(data);
  }, [data])

  useEffect(() => {
    if (clickedMore) {
      MoreBoxRef.current.style.border = `1px solid #FF8B48`;
      if (data.state === '비어있음') MoreBoxRef.current.style.height = isOver ? `180px` : `108px`;
      else MoreBoxRef.current.style.height = isOver ? `108px` : `78px`;
    }
    else {
      MoreBoxRef.current.style.border = `0px solid #FF8B48`;
      MoreBoxRef.current.style.height = `0px`;
    }
  }, [clickedMore, isOver, data])

  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  function onClickOutSide(e) {
    if (MoreBoxRef.current !== e.target 
      && MoreButtonRef.current !== e.target
      && HistoryRef.current !== e.target
      && TextRef.current !== e.target
      && LockRef.current !== e.target
      && DeleteRef.current !== e.target
      && ChangeRef.current !== e.target) {
      setClickedMore(false);
    }
  }

  function MoreButtonClick() {
    if (clickedMore) {
      setClickedMore(false);
    }
    else {
      clickMoreButtonFn();
      setClickedMore(true);
    }
  }

  // 사용자 이름 및 D-day클릭시
  function onClickMidLineWrapper() {
    if (data.memberId === 0) return;

    history.push('/member/valid/detail/' + data.memberId + '/locker');
  }

  return (
    <TopLevelWrapper>
      <InfoBox border={data.border} isOver={isOver}>
        <TopLineWrapper isOver={isOver}>
          <Number isOver={isOver}>{data.lockerName}</Number>
          <More isOver={isOver} ref={MoreButtonRef} isAvailable={data.isAvailable} onClick={MoreButtonClick}/>
        </TopLineWrapper>
        <MidLineWrapper isOver={isOver} onClick={onClickMidLineWrapper}>
          <Name isOver={isOver}>{data.userName}</Name>
          <Dday isOver={isOver}>{data.days === '' ? '' : moment(data.endDate).isAfter(moment()) ? 'D-' + data.days : 'D+' + data.days}</Dday>
        </MidLineWrapper>
        <BottomLineWrapper days={data.days} isOver={isOver}>
          <State isOver={isOver} isAvailable={data.isAvailable} isUsed={data.isUsed}>{data.state}</State>
        </BottomLineWrapper>
      </InfoBox>
      <MoreBox ref={MoreBoxRef}>
        <MoreButton ref={HistoryRef} onClick={() => clickUsageHistoryFn(index)}>이용 내역</MoreButton>
        <MoreButton ref={TextRef} onClick={() => clickFunctionFn(index)}>{data.btnText}</MoreButton>
        { data.state === '비어있음' && <MoreButton ref={LockRef} onClick={() => clickChangeStateFn(index)}>락커 잠금</MoreButton> }
        { data.state === '비어있음' && <MoreButton ref={DeleteRef} onClick={() => clickDeleteLockerFn(index)}>락커 삭제</MoreButton> }
        <MoreButton ref={ChangeRef} onClick={() => clickChangeNameFn(index)}>이름 변경</MoreButton>
      </MoreBox>
    </TopLevelWrapper>
  )
});

export default LockerInfo;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  align-items: center;

  width: ${props => props.isOver ? `109px` : `77px`};
  height: ${props => props.isOver ? `109px` : `77px`};

  // border: ${props => props.isAvailable ? props.isUsed ? `1px solid #FF8B48` : `1px solid #777777` : `1px solid #DEDEDE`};
  border: ${props => props.border};
  border-radius: 12px;
  
  transition: all 0.3s ease-in-out;
`;

const TopLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;
  
  margin-top: ${props => props.isOver ? `` : `4px`};
  margin-left: 8px;

  width: 90%;
  height: 25px;

  overflow: hidden;
`;

const Number = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: ${props => props.isOver ? `14px` : `12px`};

  color: #232323;

  margin: 0 0 0 0;

  &:hover {
    cursor: default;
  }
`;

const More = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: ${props => props.isOver ? `24px` : `17px`};
  height: ${props => props.isOver ? `24px` : `17px`};

  border-radius: 32px;

  background: ${props => props.isAvailable ? `url(${MorePath}) no-repeat center center` : `url(${ExpireMorePath}) no-repeat center center`};
  
  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background: url(${HoverMorePath}) no-repeat center center;
  }
`;

const MidLineWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;
  
  width: 100%;

  // margin-top: 4px;
  // margin-top: 0px;
  margin-left: 9px;

  &:hover {
    cursor: pointer;
  }
`;

const Name = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: ${props => props.isOver ? `14px` : `12px`};

  color: #232323;

  margin: 0 0 0 0;
`;

const Dday = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: ${props => props.isOver ? `12px` : `10px`};

  color: #A6A6A6;

  margin: 0 0 0 0;
`;

const BottomLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;

  // margin-top: ${props => props.days === '' ? '34px' : '15px'};
  margin-right: 10px;
`;


const State = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: ${props => props.isOver ? `12px` : `10px`};

  color: ${props => props.isAvailable ? props.isUsed ? `#FF8B48` : `#A6A6A6` : `#FF3131`};
  
  margin: 0 0 0 0;

  &:hover {
    cursor: default;
  }
`;

const MoreBox = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;
  overflow: hidden;

  justify-content: center;
  align-items: center;

  width: 78px;
  height: 0px;

  margin-top: 35px;
  margin-left: 60px;

  // border: 1px solid #FF8B48;
  border-radius: 8px;
  background-color: #FFFFFF;

  transition: all 0.3s ease-in-out;
`;

const MoreButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 78px;
  height: 36px;

  background-color: #FFFFFF;
  
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #FF8B48;

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #FF8B48;
    color: #FFFFFF;
  }
`;